

export const allImage = ["/image/galerie photo/01 juil 2023 Forum des associations.jpg", "/image/galerie photo/01 oct 2023 Démonstration au château de Cysoing 2.jpg",  "/image/galerie photo/01 oct 2023 Démonstration au château de Cysoing 3.jpg",
  "/image/galerie photo/01 oct 2023 Démonstration au château de Cysoing 4.jpg",
  "/image/galerie photo/01 oct 2023 Démonstration au château de Cysoing 5.jpg",
  "/image/galerie photo/01 oct 2023 Démonstration au château de Cysoing 6.jpg",
  "/image/galerie photo/01 oct 2023 Démonstration au château de Cysoing.jpg",
  "/image/galerie photo/03 dec 2023 Seclin 2.jpg",
   "/image/galerie photo/03 dec 2023 Seclin 3.jpg",
   "/image/galerie photo/03 dec 2023 Seclin 1.jpg",
   "/image/galerie photo/4 avril 2023 Tir au saucisson et bière 1.jpg",
   "/image/galerie photo/4 avril 2023 Tir au saucisson et bière 2.jpg",
   "/image/galerie photo/4 avril 2023 Tir au saucisson et bière 3.jpg",
   "/image/galerie photo/4 avril 2023 Tir au saucisson et bière 4.jpg",
   "/image/galerie photo/4 avril 2023 Tir au saucisson et bière 5.jpg",
   "/image/galerie photo/5 fev 2023 Seclin Championnat du Nord Jeunes 2.jpg",
   "/image/galerie photo/5 fev 2023 Seclin Championnat du Nord Jeunes 3.jpg",
   "/image/galerie photo/5 fev 2023 Seclin Championnat du Nord Jeunes 4.jpg",
   "/image/galerie photo/5 fev 2023 Seclin Championnat du Nord Jeunes 5.jpg",
   "/image/galerie photo/5 fev 2023 Seclin Championnat du Nord Jeunes.jpg",
   "/image/galerie photo/07 sept 2024 Repas convivial .jpg",
   "/image/galerie photo/07 sept 2024 Repas convivial 2.jpg",
   "/image/galerie photo/09 juin 2024 Comines.jpg",
   "/image/galerie photo/9 juin 2024 Comines 2.jpg",
   "/image/galerie photo/12 mai 2023 Tir au Roy.jpg",
   "/image/galerie photo/13 dec 2023 entraînement .jpg",
   "/image/galerie photo/14 avril 2024 Tir au saucisson et bière .jpg",
   "/image/galerie photo/14 avril 2024 Tir au saucisson et bière 2.jpg",
   "/image/galerie photo/14 janv 2024 .jpg",
   "/image/galerie photo/14 janv 2024 .jpg",
   "/image/galerie photo/14 janv 2024.jpg",
   "/image/galerie photo/15 janv 2023 Douai 2.jpg",
   "/image/galerie photo/15 janv 2023 Douai 3.jpg",
   "/image/galerie photo/15 janv 2023 Douai 4.jpg",
   "/image/galerie photo/15 janv 2023 Douai 5.jpg",
   "/image/galerie photo/15 janv 2023 Douai.jpg",

   "/image/galerie photo/17 dec 2023 Wingles 2.jpg",
   "/image/galerie photo/17 dec 2023 Wingles 3.jpg",
   "/image/galerie photo/17 dec 2023 Wingles 4.jpg",
   "/image/galerie photo/17 dec 2023 Wingles.jpg",

   "/image/galerie photo/17 mars 2024 Seclin 2.jpg",
   "/image/galerie photo/17 mars 2024 Seclin.jpg",

   "/image/galerie photo/18 dec 2022 Wingles 2.jpg",
   "/image/galerie photo/18 dec 2022 Wingles 3.jpg",
   "/image/galerie photo/18 dec 2022 Wingles.jpg",

   "/image/galerie photo/19 mars 2023 Tir à la Pomme Bavay 2.jpg",
   "/image/galerie photo/19 mars 2023 Tir à la Pomme Bavay.jpg",

   "/image/galerie photo/19 mars 2023 Tournoi Pro Archery .jpg",
   "/image/galerie photo/19 mars 2023 Tournoi Pro Archery 2.jpg",
   "/image/galerie photo/19 mars 2023 Tournoi Pro Archery 3.jpg",
   "/image/galerie photo/19 mars 2023 Tournoi Pro Archery 4.jpg",

   "/image/galerie photo/19 nov 2022 Tir au Maroilles 2.jpg",
   "/image/galerie photo/19 nov 2022 Tir au Maroilles 3.jpg",
   "/image/galerie photo/19 nov 2022 Tir au Maroilles.jpg",

   "/image/galerie photo/20 nov 2022 St Quentin Tir au Maroilles .jpg",
   "/image/galerie photo/20 nov 2022 St Quentin Tir au Maroilles 2.jpg",
   "/image/galerie photo/20 nov 2022 St Quentin Tir au Maroilles 3.jpg",
   "/image/galerie photo/20 nov 2022 St Quentin Tir au Maroilles 4.jpg",
   "/image/galerie photo/20 nov 2022 St Quentin Tir au Maroilles 5.jpg",
   "/image/galerie photo/20 nov 2022 St Quentin Tir au Maroilles 6.jpg",

   "/image/galerie photo/22 janv 2023 Villeneuve d'Ascq .jpg",
   "/image/galerie photo/22 janv 2023 Villeneuve d'Ascq 2.jpg",
   "/image/galerie photo/22 janv 2023 Villeneuve d'Ascq 3.jpg",
   "/image/galerie photo/22 janv 2023 Villeneuve d'Ascq 4.jpg",

   "/image/galerie photo/22 mai 2025 Tir au Prince .jpg",
   "/image/galerie photo/22 mai 2025 Tir au Prince 2.jpg",

   "/image/galerie photo/22 oct 2023 Leers 2.jpg",
   "/image/galerie photo/22 oct 2023 Leers 3.jpg",
   "/image/galerie photo/22 oct 2023 Leers 4.jpg",
   "/image/galerie photo/22 oct 2023 Leers.jpg",

   "/image/galerie photo/23 mai 2025 Roi et Princesse 2025_2.jpg",
   "/image/galerie photo/23 mai 2025 Roi et Princesse 2025.jpg",

   "/image/galerie photo/23 mai 2025 Tir au Roy 2.jpg",
   "/image/galerie photo/23 mai 2025 Tir au Roy 3.jpg",
   "/image/galerie photo/23 mai 2025 Tir au Roy 4.jpg",
   "/image/galerie photo/23 mai 2025 Tir au Roy.jpg",

   "/image/galerie photo/23 oct 2022 Leers 2.jpg",
   "/image/galerie photo/23 oct 2022 Leers 3.jpg",
   "/image/galerie photo/23 oct 2022 Leers.jpg",

   "/image/galerie photo/24 mai 2024 Tir au Roy.jpg",

   "/image/galerie photo/24 mars 2024 Tir à la Pomme .jpg",
   "/image/galerie photo/24 mars 2024 Tir à la Pomme 2.jpg",
   "/image/galerie photo/24 mars 2024 Tir à la Pomme 3.jpg",
   "/image/galerie photo/24 mars 2024 Tir à la Pomme 4.jpg",

   "/image/galerie photo/26 mars 2023 Tir Corman 2.jpg",
   "/image/galerie photo/26 mars 2023 Tir Corman 3.jpg",
   "/image/galerie photo/26 mars 2023 Tir Corman.jpg",

   "/image/galerie photo/28 janv 2024 Championnat du Nord Jeunes 2.jpg",
   "/image/galerie photo/28 janv 2024 Championnat du Nord Jeunes 3.jpg",
   "/image/galerie photo/28 janv 2024 Championnat du Nord Jeunes.jpg",

   "/image/galerie photo/29 janv 2023 Championnat du Nord  S1.jpg",
   "/image/galerie photo/29 janv 2023 Championnat du Nord S1_2.jpg"
]

export const imagePageHome = {

  fondDecran: "/background.jpg",

  quiSommesNous: "/image/qui sommes nous/6.jpg",

  competition: {
    image_1: "/image/news/Compétition villeneuve d'ascq 2023/22 janv 2023 Villeneuve d'Ascq 4.jpg",
    image_2: "/image/news/compétition leers 2023/22 oct 2023 Leers.jpg",
    image_3: "/image/news/championnat du nord jeunes 2024/28 janv 2024 Championnat du Nord Jeunes 2.jpg",
  },

  deroulementEntrainement: {
    image_1: "/image/entrainement/13 dec 2023 entraînement .jpg",
    image_2: "/image/entrainement/4.jpg",
    image_3: "/image/entrainement/5.jpg"
  },
}

export const footerImage = {
  image_1: "image/footer/img1.jpg",
}

export const imagePageQuiSommesNous = {

  fondDecran: "/image/qui sommes nous/4.jpg",

  bureau: {
    image_1: "/image/bureau/gaelle.jpg",
    image_2: "/image/bureau/arnaud.jpg",
    image_3: "/image/bureau/Aymeric.jpeg",
    image_4: "/image/bureau/iris.jpg",
    image_5: "/image/bureau/bernard.jpg",
    image_6: "/image/bureau/christian.jpg",
  },

  terrainInterieur: {
    image_1: "/image/cibleInterieur/img1.jpg",
    image_2: "/image/cibleInterieur/img3.jpg",
    image_3: "/image/cibleInterieur/img2.jpg",
  },

  terrainExterieur: {
    image_1: "/image/cibleExterieur/img10.jpg",
    image_2: "/image/cibleExterieur/img11.jpg",
    image_3: "/image/cibleExterieur/img13.jpg",
  }

}


export const listeActualite = [
    {
      picture: "/image/chocolat/img1.jpg",
      date: "30 avril 2025",
      title: "Un tir très chocolaté",
      description: "Nos jeunes adhérents ont pu participé au tir du chocolat ! Un ballon explosé égale 1 œuf en chocolat remporté! Le vainqueur de ce petit tournoi : Théodène! Suivit de près par Esther à la deuxième place ! Enfin, ex aequo, nous retrouvons Jade et Pauline sur la troisième marche du podium ! Bravo à tous nos jeunes!",
      allPircure: ["/image/chocolat/img1.jpg"]
    },
    {
      picture: "/image/news/défilé/défilé_2.jpg",
      date: "8 Mai 2025",
      title: "Le club de tir à l'arc mobilisé pour les défilés",
      description: "Le club s'est encore illustré par sa présence aux défilés du 1er et du 8 mai. Nous étions présents en grand nombres afin de porter nos couleurs aux commémorations. Un grand merci à tous ceux qui ont pu se déplacer et participer. Nous remercions tout particulièrement notre porte-drapeau Cyprien de nous avoir ouvert la marche.",
      allPircure: ["/image/news/défilé/défilé_1.jpg", "/image/news/défilé/défilé_2.jpg", "/image/news/défilé/défilé_3.jpg", "/image/news/défilé/défilé_4.jpg"]
    },
    {
      picture: "/image/cibleExterieur/img3.jpg",
      date: "15 Mai 2025",
      title: "Le pas de tir extérieur est de nouveau ouvert",
      description: "Bonne nouvelle pour les archers adeptes du tir en extérieur ! Le pas de tir extérieur a été remis en état pour la saison estivale. Quelques changements ont été opérés concernant les cibles : Nous avons désormais une cible à 18m, 4 à 30m et enfin, 2 à 50m. Un grand merci à tous les adhérents ayant participé à son entretient durant les jours fériés.",
      allPircure: ["/image/cibleExterieur/img1.jpg", "/image/cibleExterieur/img2.jpg", "/image/cibleExterieur/img3.jpg", "/image/cibleExterieur/img4.jpg", "/image/cibleExterieur/img5.jpg", "/image/cibleExterieur/img6.jpg", "/image/cibleExterieur/img7.jpg", "/image/cibleExterieur/img8.jpg", "/image/cibleExterieur/img9.jpg", "/image/cibleExterieur/img10.jpg", "/image/cibleExterieur/img11.jpg", "/image/cibleExterieur/img12.jpg", "/image/cibleExterieur/img13.jpg"]
    },
    {
      picture: "/image/news/tir au prince 2025/22 mai 2025 Tir au Prince 2.jpg",
      date: "21 Mai 2025",
      title: "Longue vie à notre princesse !",
      description: "Le club de tir à l'arc a organisé ce 21 mai 2025 sa première édition du 'tir du prince'. Nos jeunes adhérents de tir à l'arc ont pu se frotter à l'épreuve de l'oiseau pour la première fois. Leur objectif ? Tirer sur l'oiseau le premier. L'habile archère ayant réalisé cet exploit est notre chère Cléa ! Elle repart avec son trophée, sa proie et une petite assiette finement décorée des armoiries historiques du club en souvenir de l'évènement. Bravo à elle !",
      allPircure: ["/image/news/tir au prince 2025/22 mai 2025 Tir au Prince .jpg", "/image/news/tir au prince 2025/22 mai 2025 Tir au Prince 2.jpg"]
    },
    {
      picture: "/image/news/Tir au roy 2025/23 mai 2025 Tir au Roy 1.jpg",
      date: "23 Mai 2025",
      title: "Qui part à la chasse… garde sa place !",
      description: "Le roi Arnaud a remis sa couronne en jeu cette année ainsi que les rôles de capitaine et de sergent jusque-là détenus par Gaelle et Louis. Cependant, la couronne n'a pas eu le temps d'effleurer une autre tête qu'elle était déjà retournée sur la sienne. Pour la deuxième année consécutive, Arnaud a réalisé l'exploit de tuer l'oiseau dès le tir de lancement de l'évènement, ne laissant aucune chance à ses adversaires de le détrôner. Il est donc sacré roi une fois encore. Longue année au roi! Une troisième fois d'affiler et il pourra endosser le titre honorifique d'empereur. /nIl a par la suite été rejoint par le capitaine Christian et le sergent David. Grâce à eux, les trois catégories d'arc sont représentées cette année./nFélicitations à vous 3 messieurs et belle année à vous!",
      allPircure: ["/image/news/Tir au roy 2025/23 mai 2025 Tir au Roy 1.jpg", "/image/news/Tir au roy 2025/23 mai 2025 Tir au Roy 2.jpg", "/image/news/Tir au roy 2025/23 mai 2025 Tir au Roy 3.jpg", "/image/news/Tir au roy 2025/23 mai 2025 Tir au Roy 4.jpg"]
    
    }   
  ]